// import Services from '@/services/index';
// import VT from '@/store/types';

export default {
  // [VT.PROJECT_USER_DELETE]: ({}, id) => {
  //   return new Promise((resolve, reject) => {
  //     Services.projectUsers.delete(id).then((data) => {
  //       resolve(data);
  //     }).catch((data) => {
  //       reject(data);
  //     });
  //   });
  // },
};
